import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { alertsState, IAlertsItem } from 'widgets/Alerts/model/types';

const initialState: alertsState = {
	alertIdList: [],
	alertList: [],
};

export const alertsSlice = createSlice({
	name: 'alerts',
	initialState,
	reducers: {
		alertsPushItem: (state, action: PayloadAction<IAlertsItem>) => {
			state.alertList.push(action.payload);
			state.alertIdList.push(action.payload.id);
		},
		alertsSetItems: (state, action: PayloadAction<IAlertsItem[]>) => {
			state.alertList = action.payload;
		},
		alertsDeleteItem: (state, action: PayloadAction<string>) => {
			state.alertList = state.alertList.filter((item) => item.id !== action.payload);
		},
		alertsDeleteItemId: (state, action: PayloadAction<string>) => {
			state.alertIdList = state.alertIdList.filter((id) => id !== action.payload);
		},
	},
});

export default alertsSlice.reducer;

export const { alertsPushItem, alertsSetItems, alertsDeleteItem, alertsDeleteItemId } = alertsSlice.actions;
